document.addEventListener('DOMContentLoaded', function () {
  var tocNavs = document.querySelectorAll('[data-article-toc]');
  if (!tocNavs.length) return;

  var content = document.querySelector('.article-template__content');
  var tocBoxes = Array.prototype.map.call(tocNavs, function (nav) {
    return nav.closest('.article-sidebar-box');
  });

  if (!content) {
    tocBoxes.forEach(function (box) {
      if (box) box.hidden = true;
    });
    return;
  }

  var headings = content.querySelectorAll('h2, h3');
  if (!headings.length) {
    tocBoxes.forEach(function (box) {
      if (box) box.hidden = true;
    });
    return;
  }

  var usedIds = {};
  var slugify = function (text) {
    var base = (text || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
    if (!base) base = 'section';
    var id = base;
    var i = 1;
    while (usedIds[id]) {
      id = base + '-' + i;
      i += 1;
    }
    usedIds[id] = true;
    return id;
  };

  var items = [];
  headings.forEach(function (heading) {
    if (!heading.id) {
      heading.id = slugify(heading.textContent);
    } else {
      usedIds[heading.id] = true;
    }
    items.push(heading);
  });

  tocNavs.forEach(function (nav) {
    var list = nav.querySelector('[data-toc-list]');
    if (!list) return;
    items.forEach(function (heading) {
      var li = document.createElement('li');
      li.className = 'article-toc__item article-toc__item--' + heading.tagName.toLowerCase();

      var a = document.createElement('a');
      a.href = '#' + heading.id;
      a.className = 'article-toc__link';
      a.textContent = heading.textContent;

      li.appendChild(a);
      list.appendChild(li);
    });
  });

  var links = document.querySelectorAll('.article-toc__link');
  if (!links.length || !('IntersectionObserver' in window)) return;

  var setActive = function (id) {
    links.forEach(function (link) {
      link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
    });
  };

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setActive(entry.target.id);
        }
      });
    },
    { rootMargin: '-20% 0px -70% 0px' }
  );

  items.forEach(function (heading) {
    observer.observe(heading);
  });
});
